import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const RoleMappingSlice = createSlice({
    name: "RoleMapping",
    initialState: {} as IReduxState<any>,
    reducers: {
        getRoleMapping: (state) => {
            state.isLoading = true;
        },
        successGetRoleMapping: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        failureGetRoleMapping: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        clearRoleMapping: (state) => {
            state.data = {};
        },
    },
});

export const {
    getRoleMapping,
    successGetRoleMapping,
    failureGetRoleMapping,
    clearRoleMapping,
} = RoleMappingSlice.actions;

export default RoleMappingSlice.reducer;
